<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg', headerClass: 'type-2' }" :title="String($t('user_page.approval_step_update'))")
    b-container(fluid)
      .content-wrap
        p {{$t('user_page.confirm_update_mid_manager_approval_step')}}

        .select-items
          span(v-for="item of selected" :key="item.pk") '{{ item.name }}'
        
        b-radio-group.radio(v-model="form.selected" :options="selectOptions.list" size="sm")

        .cmt
          p ※ {{$t('user_page.policy_manager_fixed_approval_step')}}

      .modal-footer
        b-button(size="sm" variant="primary" @click="submit" pill) {{$t('change')}}
        b-button(size="sm" variant="secondary" @click="visible = false" pill) {{$t('close')}}
</template>

<script>
import Dialogs from "@/components/mixins/dialog/index.vue"
import { ApprovalAPI } from "@/api"
import _ from "lodash"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Dialogs,
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.visible = newVal
        if (this.selected.length === 1) {
          this.form.selected = this.selected[0].manage_seq
        } else {
          this.form.selected = null
        }
      },
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      form: { selected: null },
      selectOptions: {
        list: [
          { text: this.$t('total'), value: "9" },
          { value: "0", text: this.$t('user_page.not_set') },
          { value: "1", text: `1${this.$t('step')}` },
          { value: "2", text: `2${this.$t('step')}` },
          { value: "3", text: `3${this.$t('step')}` },
          { value: "4", text: `4${this.$t('step')}` },
        ],
      },
    }
  },
  methods: {
    async submit() {
      if (!this.form.selected) {
        this.$bvToast.toast(this.$t('user_page.select_approval_step'), {
          title: "Error",
          variant: "danger",
          solid: true,
        })
        return
      }
      for (const item of this.selected) {
        const params = {
          pk: item.pk,
          manage_seq: parseInt(this.form.selected),
        }
        await ApprovalAPI.approvalLine.put("", params)
      }
      this.$emit("complete")
    },
  },
}
</script>

<style lang="scss" scoped>
.content-wrap {
  text-align: center;
  font-size: 15px;
  p {
    margin-bottom: 0;
    padding-bottom: 10px;
  }
}
.radio {
  padding: 20px 0 30px;
}
.cmt {
  p {
    padding: 0;
    color: #6f6f6f;
  }
}
</style>
